/* SANTOS ATHLETIC — theme script */
(function () {
  'use strict';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------- Header height ---------- */
  function setHeaderHeight() {
    var h = $('[data-santos-header]');
    if (h) document.documentElement.style.setProperty('--header-height', h.offsetHeight + 'px');
  }
  window.addEventListener('resize', setHeaderHeight);
  document.addEventListener('DOMContentLoaded', setHeaderHeight);
  setHeaderHeight();

  /* ---------- Drawers ---------- */
  function openDrawer(id) {
    var d = document.getElementById(id);
    if (!d) return;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('has-open-drawer');
    var f = d.querySelector('[data-autofocus]');
    if (f) setTimeout(function () { f.focus(); }, 50);
  }
  function closeDrawer(d) {
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    if (!$('.drawer.is-open')) document.body.classList.remove('has-open-drawer');
  }
  window.SantosDrawer = { open: openDrawer, close: closeDrawer };
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      e.preventDefault();
      if (opener.getAttribute('data-drawer-open') === 'cart-drawer' && document.body.dataset.template === 'cart') { window.location.href = root + 'cart'; return; }
      openDrawer(opener.getAttribute('data-drawer-open'));
      return;
    }
    var closer = e.target.closest('[data-drawer-close]');
    if (closer) { e.preventDefault(); closeDrawer(closer.closest('.drawer')); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') $$('.drawer.is-open').forEach(closeDrawer);
  });

  /* ---------- Header search panel ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-search-toggle]');
    if (!t) return;
    e.preventDefault();
    var panel = $('[data-search-panel]');
    if (!panel) return;
    var open = panel.hasAttribute('hidden');
    panel.toggleAttribute('hidden', !open);
    if (open) { var i = panel.querySelector('input'); if (i) i.focus(); }
  });

  /* ---------- Cart ---------- */
  function updateCartCount(count) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = count; });
    $$('[data-cart-dot]').forEach(function (el) { el.classList.toggle('is-visible', count > 0); });
  }
  function renderCartDrawer(html) {
    var drawer = document.getElementById('cart-drawer');
    if (!drawer || !html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('#cart-drawer');
    if (fresh) drawer.innerHTML = fresh.innerHTML;
    var countEl = doc.querySelector('[data-cart-item-count]');
    if (countEl) updateCartCount(parseInt(countEl.getAttribute('data-cart-item-count'), 10) || 0);
  }
  function refreshCart() {
    return fetch(root + '?sections=santos-cart-drawer').then(function (r) { return r.json(); }).then(function (s) {
      renderCartDrawer(s['santos-cart-drawer']);
    });
  }
  window.SantosCart = { refresh: refreshCart };

  function addToCart(form, button) {
    var data = new FormData(form);
    data.append('sections', 'santos-cart-drawer');
    data.append('sections_url', window.location.pathname);
    if (button) button.setAttribute('aria-busy', 'true');
    return fetch(root + 'cart/add.js', { method: 'POST', body: data, headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (button) button.removeAttribute('aria-busy');
        if (res.status) {
          var err = form.querySelector('[data-form-error]');
          if (err) { err.textContent = res.description || res.message; err.hidden = false; }
          return;
        }
        if (res.sections) renderCartDrawer(res.sections['santos-cart-drawer']);
        else refreshCart();
        if (document.body.dataset.template === 'cart') { window.location.reload(); return; }
        openDrawer('cart-drawer');
      })
      .catch(function () { form.submit(); });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-product-form]');
    if (!form) return;
    e.preventDefault();
    var button = form.querySelector('[type="submit"]') || e.submitter;
    var real = e.submitter || button;
    if (real && real.hasAttribute('data-atc-animate')) {
      if (!real.querySelector('.atc-check')) real.insertAdjacentHTML('beforeend', '<span class="atc-check" aria-hidden="true"><svg width="26" height="26" viewBox="0 0 24 24" fill="none"><path d="M4 12.5l5 5L20 6.5" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg></span>');
      void real.offsetWidth;
      real.classList.add('is-added');
      setTimeout(function () { addToCart(form, real); }, 700);
      setTimeout(function () { real.classList.remove('is-added'); }, 2800);
    } else {
      addToCart(form, real);
    }
  });

  function changeLine(line, qty) {
    var drawer = document.getElementById('cart-drawer');
    if (drawer) drawer.classList.add('is-loading');
    return fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty, sections: ['santos-cart-drawer'], sections_url: window.location.pathname })
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (drawer) drawer.classList.remove('is-loading');
      if (document.body.dataset.template === 'cart') { window.location.reload(); return; }
      if (res.sections) renderCartDrawer(res.sections['santos-cart-drawer']);
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-line-change]');
    if (!b) return;
    e.preventDefault();
    changeLine(parseInt(b.getAttribute('data-line'), 10), parseInt(b.getAttribute('data-line-change'), 10));
  });
  document.addEventListener('change', function (e) {
    var i = e.target.closest('[data-line-input]');
    if (!i) return;
    changeLine(parseInt(i.getAttribute('data-line'), 10), Math.max(0, parseInt(i.value, 10) || 0));
  });

  /* ---------- Quantity selectors (product page) ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty-step]');
    if (!b) return;
    var input = b.parentNode.querySelector('input');
    var v = (parseInt(input.value, 10) || 1) + parseInt(b.getAttribute('data-qty-step'), 10);
    input.value = Math.max(1, v);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Carousels ---------- */
  function initCarousels(scope) {
    $$('[data-carousel]', scope).forEach(function (wrap) {
      if (wrap.__init) return;
      wrap.__init = true;
      var track = wrap.querySelector('[data-carousel-track]');
      var prev = wrap.querySelector('[data-carousel-prev]');
      var next = wrap.querySelector('[data-carousel-next]');
      if (!track) return;
      function update() {
        var max = track.scrollWidth - track.clientWidth;
        wrap.classList.toggle('is-scrollable', max > 2);
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max - 2;
      }
      function step(dir) {
        var card = track.firstElementChild;
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        var per = card ? Math.max(1, Math.round(track.clientWidth / (card.offsetWidth + gap))) : 1;
        track.scrollBy({ left: dir * per * ((card ? card.offsetWidth : track.clientWidth) + gap), behavior: 'smooth' });
      }
      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }
  window.SantosCarousels = initCarousels;

  /* ---------- Reveal on scroll (staggered product cards) ---------- */
  function initReveal(scope) {
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var items = en.target.__items || [];
        items.forEach(function (it, i) { setTimeout(function () { it.classList.add('is-revealed'); }, i * 80); });
        io.unobserve(en.target);
      });
    }, { rootMargin: '0px 0px -60px 0px' });
    $$('[data-reveal-list]', scope).forEach(function (list) {
      if (list.__reveal) return;
      list.__reveal = true;
      var items = $$('.product-card', list).slice(0, 8);
      items.forEach(function (it) { it.classList.add('reveal-on-scroll'); });
      list.__items = items;
      io.observe(list);
    });
  }

  /* ---------- Product recommendations ---------- */
  function initRecommendations() {
    $$('[data-recommendations-url]').forEach(function (el) {
      if (el.__loaded) return;
      el.__loaded = true;
      fetch(el.getAttribute('data-recommendations-url')).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-recommendations-url]');
        if (fresh && fresh.innerHTML.trim()) {
          el.innerHTML = fresh.innerHTML;
          el.hidden = false;
          var host = el.closest('[data-recommendations-host]');
          if (host) host.hidden = false;
          initCarousels(el);
        }
      });
    });
  }

  /* ---------- Collection filters ---------- */
  document.addEventListener('change', function (e) {
    var form = e.target.closest('form[data-facets-form]');
    if (!form) return;
    var params = new URLSearchParams(new FormData(form));
    Array.from(params.keys()).forEach(function (k) { if (params.get(k) === '') params.delete(k); });
    window.location.search = params.toString();
  });

  /* ---------- Init ---------- */
  function init() {
    setHeaderHeight();
    initCarousels(document);
    initReveal(document);
    initRecommendations();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function (e) { initCarousels(e.target); initReveal(e.target); initRecommendations(); setHeaderHeight(); });
})();